var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.locale},scopedSlots:_vm._u([{key:"renderEmpty",fn:function(){return [_c('a-empty',{attrs:{"description":"暂无数据"}})]},proxy:true}])},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_c('personal-info-protection-notice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }